//TODO: add more suitable parameter instead of <any>
import type {FormikProps} from 'formik';
import type ValueList from '@interfaces/ValueList';

type Values = ValueList<any>;

export function isValid(formik: FormikProps<Values>): boolean {
    const {touched, errors} = formik;

    return Object.keys(errors).reduce((acc: boolean, item: keyof Values) => {
        if (touched[item] && errors[item]) {
            return false;
        }

        return acc;
    }, true);
}
